module.exports = __webpack_public_path__ + "img/J_mask.2d002017.png";